<div class="card shadow contact-card">
    <div class="card-body">
        <h3>How can we help?</h3>

        <form class="contact-form" [formGroup]="tutorSupportForm">

            <p class="m-0 font-size-16">
                <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="firstName" placeholder="First Name">
                    <mat-error *ngIf="f.firstName.hasError('required')">First name is required</mat-error>
                    <mat-error *ngIf="f.firstName.hasError('minLength')">First name must be at least 2 characters</mat-error>
                    <mat-error *ngIf="f.firstName.hasError('pattern')">First name should only contain letters</mat-error>
                </mat-form-field>
            </p>
        
            <p class="m-0 font-size-16">
                <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="lastName" placeholder="Last Name">
                    <mat-error *ngIf="f.lastName.hasError('required')">Last name is required</mat-error>
                    <mat-error *ngIf="f.lastName.hasError('minLength')">Last name must be at least 2 characters</mat-error>
                    <mat-error *ngIf="f.lastName.hasError('pattern')">Last name should only contain letters</mat-error>
                </mat-form-field>
            </p>

            <p class="m-0 font-size-16">
                <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                    <mat-label>Email Address</mat-label>
                    <input matInput formControlName="emailAddress" placeholder="Email Address">
                    <mat-error *ngIf="f.emailAddress.hasError('required')">Email is required</mat-error>
                    <mat-error *ngIf="f.emailAddress.hasError('pattern')">Email must be valid</mat-error>
                </mat-form-field>
            </p>
        
            <p class="m-0 font-size-16">
                <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                    <mat-label>Contact number</mat-label>
                    <input matInput formControlName="phoneNumber" placeholder="Contact Number">
                    <mat-error *ngIf="f.phoneNumber.hasError('required')">Contact number is required</mat-error>
                    <mat-error *ngIf="f.phoneNumber.hasError('pattern')">Contact number must be numeric</mat-error>
                </mat-form-field>
            </p>

            <p class="m-0 font-size-16">
                <mat-form-field appearance="standard" class="w-100 mat-custom-select" floatLabel="never">
                    <mat-select class="py-4 px-4 rounded" placeholder="Select institute"
                        style="border: 1px solid #cdd6df;" formControlName="institute" (selectionChange)="instituteChanged($event)">
                        <mat-option value="">Select Institute</mat-option>
                        <mat-option [value]="institute" *ngFor="let institute of courses">{{ institute?.CourseName?._text }}</mat-option>
                    </mat-select>

                    <mat-error *ngIf="f.institute.hasError('required')">Institute is required</mat-error>
                </mat-form-field>
            </p>

            <p class="m-0 font-size-16 mt-5">
                <mat-form-field appearance="standard" class="w-100 mat-custom-select" floatLabel="never">
                    <mat-select class="py-4 px-4 rounded" placeholder="Select subject"
                        style="border: 1px solid #cdd6df;" formControlName="subject">
                        <mat-option value="">Select Subject</mat-option>
                        <mat-option [value]="subject" *ngFor="let subject of subjects">{{ subject?.title }}</mat-option>
                    </mat-select>

                    <mat-error *ngIf="f.subject.hasError('required')">Subject is required</mat-error>
                </mat-form-field>
            </p>

            <p class="m-0 font-size-16 mt-5">
                <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                    <mat-label>Study Material</mat-label>
                    <input matInput formControlName="studyMaterial" placeholder="Which study material does your query refer to?">
                    <mat-error *ngIf="f.studyMaterial.hasError('required')">Study Material is required</mat-error>
                </mat-form-field>
            </p>

            <p class="m-0 font-size-16">
                <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                    <mat-label>Page Number</mat-label>
                    <input matInput formControlName="pageNumber" placeholder="Which page number does your query refer to?">
                    <mat-error *ngIf="f.pageNumber.hasError('required')">Page Number is required</mat-error>
                </mat-form-field>
            </p>

            <p class="m-0 font-size-16">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Query</mat-label>
                    <textarea rows="3" matInput formControlName="query" placeholder="How can we help?"></textarea>
                    <mat-error *ngIf="f.query.hasError('required')">Query is required</mat-error>
                </mat-form-field>
            </p>

            <p class="mt-0 mb-10 font-size-13">
                <mat-checkbox formControlName="subscribe">I would like to receive course related updates, news and promotional information from IBTC.</mat-checkbox>
            </p>

            <div class="form-group">
                <button *ngIf="!processing" type="button" (click)="saveChanges()" class="btn btn-lg rounded-pill font-size-16 font-weight-bold btn-primary btn-block">Submit</button>

                <div *ngIf="processing" class="d-flex justify-content-center align-items-center preloader">
                    <mat-spinner diameter="24"></mat-spinner>
                </div>
            </div>

            <p class="text-center" style="font-size: 12px; color: #828b91;">Please note that it can take up to 2 working days to receive an answer.</p>

            <div class="d-flex align-items-center justify-content-center" *ngIf="success">
                <img loading="lazy" src="assets/img/icons/icn-check-green.svg" class="mr-3" /> <span class="font-size-16">Successfully sent your message!</span>
            </div>
        </form>
    </div>
</div>
